module.exports = __webpack_public_path__ + "img/HannahOld.9493031e.gif";